import React from 'react';
import { Link } from "react-router-dom";

export const CheckoutPayment = () => {
  return (
    <div className="lg:p-8 p-4 border-r-[1px] 2xl:h-screen">
      <div className="w-full lg:w-5/6 2xl:w-9/12 lg:ml-auto">

        <div>
          <h1><Link to="/"><img src="images/logo.svg" alt="Sightkart" className="w-52" /></Link></h1>
          <ul className="checkout_list flex text-sm mt-4 mb-6 text-gray-500">
            <li><Link to="/checkout"><span className="text-cyan-500">Information</span></Link></li>
            <li><Link to="/shipping"><span className="text-cyan-500">Shipping</span></Link></li>
            <li><span className="font-medium">Payment</span></li>
          </ul>
        </div>

        <div className="border rounded p-4">
          <div className="flex text-sm mb-3 md:gap-5 gap-3 text-gray-500">
            <div>Contact</div>
            <div>surinder.techies@gmail.com</div>
            <div className="ml-auto text-cyan-500"><Link to="/checkout">Change</Link></div>
          </div>
          <hr />
          <div className="flex text-sm mt-3 mb-3 md:gap-5 gap-3 text-gray-500">
            <div>Ship to</div>
            <div>Sarabha Nagar, SCF 12 c, 141001 Ludhiana</div>
            <div className="ml-auto text-cyan-500"><Link to="/checkout">Change</Link></div>
          </div>
          <hr />
          <div className="flex text-sm mt-3 md:gap-5 gap-3 text-gray-500">
            <div>Method</div>
            <div>Standard · <span className="font-medium text-gray-700">$20.00</span></div>
            <div className="ml-auto text-cyan-500"></div>
          </div>
        </div>

        <h3 className="text-xl text-gray-700 mt-8">Payment</h3>
        <p className="text-sm text-gray-600 mb-4 mt-1">All transactions are secure and encrypted.</p>

        <div className="border rounded">
          <div className="flex justify-between items-center border-b-[1px]">
            <div className="inline-block content-center p-3 gap-2 text-gray-600"><input type="radio" name="" checked /> Credit card</div>
            <div className="pr-3"><img src="images/cards.png" alt="Cards" className="w-36 " /></div>
          </div>
          <div className="bg-gray-100 p-4">
            <div class="relative">
              <input type="text" class="w-full mb-3 p-1 pt-4 px-4 placeholder-transparent border border-gray-200 rounded-md peer focus:outline-none focus:border-gray-500 focus:shadow-sm text-gray-700" placeholder="Card Number" autocomplete="off" />
              <label for="name" class="absolute top-0 left-0 h-full px-4 py-3 text-sm transition-all duration-100 ease-in-out origin-left transform scale-75 translate-x-1 -translate-y-3 opacity-75 pointer-events-none peer-placeholder-shown:opacity-100 peer-focus:opacity-75 peer-placeholder-shown:scale-100 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 peer-focus:translate-x-1 text-gray-500">Card Number</label>
            </div>
            <div class="relative">
              <input type="text" class="w-full mb-3 p-1 pt-4 px-4 placeholder-transparent border border-gray-200 rounded-md peer focus:outline-none focus:border-gray-500 focus:shadow-sm text-gray-700" placeholder="Card Holder Name" autocomplete="off" />
              <label for="name" class="absolute top-0 left-0 h-full px-4 py-3 text-sm transition-all duration-100 ease-in-out origin-left transform scale-75 translate-x-1 -translate-y-3 opacity-75 pointer-events-none peer-placeholder-shown:opacity-100 peer-focus:opacity-75 peer-placeholder-shown:scale-100 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 peer-focus:translate-x-1 text-gray-500">Card Holder Name</label>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div class="relative">
                <input type="text" class="w-full p-1 pt-4 px-4 placeholder-transparent border border-gray-200 rounded-md peer focus:outline-none focus:border-gray-500 focus:shadow-sm text-gray-700" placeholder="Expiration date (MM / YY)" autocomplete="off" />
                <label for="name" class="absolute top-0 left-0 h-full px-4 py-3 text-sm transition-all duration-100 ease-in-out origin-left transform scale-75 translate-x-1 -translate-y-3 opacity-75 pointer-events-none peer-placeholder-shown:opacity-100 peer-focus:opacity-75 peer-placeholder-shown:scale-100 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 peer-focus:translate-x-1 text-gray-500">Expiration date (MM / YY)</label>
              </div>
              <div class="relative">
                <input type="text" class="w-full p-1 pt-4 px-4 placeholder-transparent border border-gray-200 rounded-md peer focus:outline-none focus:border-gray-500 focus:shadow-sm text-gray-700" placeholder="Security code" autocomplete="off" />
                <label for="name" class="absolute top-0 left-0 h-full px-4 py-3 text-sm transition-all duration-100 ease-in-out origin-left transform scale-75 translate-x-1 -translate-y-3 opacity-75 pointer-events-none peer-placeholder-shown:opacity-100 peer-focus:opacity-75 peer-placeholder-shown:scale-100 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 peer-focus:translate-x-1 text-gray-500">Security code</label>
              </div>
            </div>

          </div>
        </div>

        <h3 className="text-xl text-gray-700 mt-8">Billing address</h3>
        <p className="text-sm text-gray-600 mb-4 mt-1">Select the address that matches your card or payment method.</p>

        <div className="border rounded">
          <div className="text-sm gap-5 text-gray-500 p-4">
            <div><label className="content-center flex gap-1" style={{display: '-webkit-box'}}><input type="radio" name="shipping" checked="checked" /> Same as shipping address</label></div>
          </div>
          <hr />
          <div className="text-sm gap-5 text-gray-500 p-4">
            <div><label className="content-center flex gap-1" style={{display: '-webkit-box'}}><input type="radio" name="shipping" /> Use a different billing address</label></div>
          </div>
        </div>

        <h3 className="text-xl text-gray-700 mt-8 mb-2">Remember me</h3>
        <div className="border rounded">
          <div className="text-sm gap-5 text-gray-500 p-4">
            <label className="content-center flex gap-1" style={{display: '-webkit-box'}}><input type="checkbox" name="" /> Save my information for a faster checkout</label>
          </div>
        </div>

        <div className="flex mt-10 justify-between items-center">
          <div className="text-cyan-500">
            <Link to="/shipping"><i className="fa fa-angle-left mr-3"></i> Return to information</Link>
          </div>
          <div>
            <Link to="/thankyou" className="bg-cyan-500 uppercase text-white font-light rounded py-3 px-8 mt-2 ml-auto">Pay Now</Link>
          </div>
        </div>

        <div className="content-end hidden md:inline-block">
          <hr className="mt-6 mb-4" />
          <div className="flex gap-4 text-cyan-500 text-sm font-light">
            <a href="#" target="_blank" rel="noopener noreferrer">Refund policy</a>
            <a href="#" target="_blank" rel="noopener noreferrer">Shipping policy</a>
            <a href="#" target="_blank" rel="noopener noreferrer">Privacy policy</a>
            <a href="#" target="_blank" rel="noopener noreferrer">Terms of service</a>
          </div>
        </div>

      </div>
    </div>
  )
}